import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import Layout from './components/Layout';
import Home from './pages/Home';
import MeetingRoom from './pages/MeetingRoom';
import BookTour from './pages/BookTour';
import PlanConsultation from './pages/PlanConsultation';
import Login from './pages/Login';
import MeetingRoomSurvey from './pages/MeetingRoomSurvey';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/meeting-room" element={<MeetingRoom />} />
          <Route path="/tour" element={<BookTour />} />
          <Route path="/consultation" element={<PlanConsultation />} />
          <Route path="/login" element={<Login />} />
          <Route path="/meetings/1602b/reserve" element={<MeetingRoomSurvey />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
